import { render, staticRenderFns } from "./TabbedUsersPage.vue?vue&type=template&id=66993940&scoped=true"
import script from "./TabbedUsersPage.vue?vue&type=script&lang=js"
export * from "./TabbedUsersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66993940",
  null
  
)

export default component.exports